import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Loader2, Upload } from "lucide-react";

export const AgreementModal = ({ lease, open, onOpenChange, onSubmit, saving }) => {
  const [file, setFile] = useState(null);
  const [terms, setTerms] = useState("");

  useEffect(() => {
    if (open) {
      setFile(null);
      setTerms(lease?.agreement?.terms || "");
    }
  }, [open, lease]);

  const hasChanges = file || terms !== (lease?.agreement?.terms || "");

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border-slate-800" data-testid="agreement-modal">
        <DialogHeader>
          <DialogTitle className="text-white">Lease Agreement</DialogTitle>
          <DialogDescription className="text-slate-400">
            {lease?.tenant_name} — {lease?.asset_name || "property"}. Attach the signed agreement and set out its terms.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label className="text-slate-300">Agreement file (PDF, image or document)</Label>
            <Input
              type="file"
              accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
              onChange={(e) => setFile(e.target.files?.[0] || null)}
              className="input-default file:text-slate-300 file:bg-slate-800 file:border-0 file:rounded file:px-2 file:mr-3"
              data-testid="agreement-file-input"
            />
            {lease?.agreement?.filename && !file && (
              <p className="text-xs text-slate-500">Current file: {lease.agreement.filename}</p>
            )}
          </div>
          <div className="space-y-2">
            <Label className="text-slate-300">Terms &amp; Conditions</Label>
            <Textarea
              value={terms}
              onChange={(e) => setTerms(e.target.value)}
              placeholder="Set out the key terms: rent, deposit, notice period, renewal, maintenance responsibilities..."
              rows={6}
              className="input-default"
              data-testid="agreement-terms-input"
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" className="btn-secondary" onClick={() => onOpenChange(false)} data-testid="agreement-cancel-btn">
            Cancel
          </Button>
          <Button
            className="btn-primary"
            disabled={saving || !hasChanges}
            onClick={() => onSubmit(lease, file, terms)}
            data-testid="agreement-save-btn"
          >
            {saving ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Upload className="w-4 h-4 mr-2" />}
            Save Agreement
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
